<app-company-info
  [companyInitials]="companyInitials"
  [company]="company"
></app-company-info>
<mat-card>
  <mat-card-content>
    <div class="header-wrapper">
      <div class="header-wrapper-left-button">
        <button aria-label="collapse" mat-button="" (click)="_location.back()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div>
          <span class="mat-h2">{{ 'USERS.BlockedUsers' | translate }}</span>
        </div>
      </div>
      <div class="header-wrapper-right-button">
        <div
          [matTooltip]="
          this.selection.hasValue()
              ? ('UnBlock_User' | translate)
              : ('UnBlock_User_Disabled' | translate)
          "
        >
          <button
            mat-stroked-button
            color="primary"
            aria-label="plus"
            mat-button=""
            (click)="unblockUser()"
            [disabled]="!this.selection.hasValue()"
          >
            <mat-icon>undo</mat-icon>
            <span>{{ 'UnBlock_User' | translate }}</span>
          </button>
        </div>
        <div
          [matTooltip]="
          this.selection.hasValue()
              ? ('Delete_User' | translate)
              : ('Delete_User_Disabled' | translate)
          "
        >
          <button
            mat-stroked-button
            color="primary"
            aria-label="trash"
            mat-button=""
            (click)="deleteUser()"
            [disabled]="!this.selection.hasValue()"
          >
            <mat-icon>delete_outline</mat-icon>
            <span>{{ 'Delete_User' | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    @if (noRecordFound) {
    <app-not-found
      [displayMessage]="message"
    ></app-not-found>
    }

    <table
      mat-table
      [dataSource]="blockedUsersDataSource"
      [ngClass]="noRecordFound ? 'hide' : ''"
      matSort
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation(); masterToggle()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            [disabled]="blockedUsersDataSource === undefined"
          >
          </mat-checkbox>
        </th>
        <td mat-cell class="border" *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef width="50%">
          {{ 'COMPANY_USERS.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let blockedUser">{{ blockedUser.name }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef width="50%">
          {{ 'COMPANY_USERS.email' | translate }}
        </th>
        <td mat-cell *matCellDef="let blockedUser">{{ blockedUser.email }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
    @if (!noRecordFound) {
    <mat-paginator
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[10, 25, 50, 100]"
    ></mat-paginator>
    }
  </mat-card-content>
</mat-card>
@if (_usersService.loading) {
<app-spinner></app-spinner>
}
